import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from "@angular/material/snack-bar";
import { INotificationData, TNotificationSeverity } from './notification.service';

// Material-icoon per soort; offline-meldingen houden het cloud_off-icoon.
const SEVERITY_ICON: Record<TNotificationSeverity, string> = {
    info: 'info',
    success: 'check_circle',
    warning: 'warning',
    error: 'error',
};
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    standalone: true,
    imports: [
        MatIcon
    ],
    styleUrls: ['./notification.component.scss']
})
export class NotificationComponent {

    messages: INotificationData[] = [];

    text = {
        close: 'close',
    };

    severity(message: INotificationData): TNotificationSeverity {
        return message.severity ?? 'info';
    }

    icon(message: INotificationData): string {
        return message.offline ? 'cloud_off' : SEVERITY_ICON[this.severity(message)];
    }

    constructor(
        public snackBarRef: MatSnackBarRef<NotificationComponent>,
        @Inject(MAT_SNACK_BAR_DATA) public data: any) 
    {
        this.messages = this.data.messages;
    }

    removeMessage(message: INotificationData) {
        this.messages.splice(this.messages.indexOf(message), 1);
        if (this.messages.length === 0) {
            this.snackBarRef.dismiss();
        }
    }
}